export default "__VITE_ASSET__BRrfCijd__"